import http from './httpService';
import config from './../config.json';

export const getAllUsers = (params, {cancelToken}) => {
	return http.get(config.api_user, {params, cancelToken});
}

export const getUserById = (_id, {cancelToken}) => {
	return http.get(`${config.api_user}/${_id}`, {cancelToken});
}

export const getUserByMobileNumber = (_id) => {
	return http.get(`${config.api_user}/fetch-user/${_id}`);
}

export const blockingUser = (_id) => {
    return http.get(`${config.api_user}/blocking/${_id}`);
}

export const sendMobileNumber = (phoneNumber) => {
	return http.get(`${config.api_user}/sending-mobilenumber/${phoneNumber}`);
}

export const sendVerificationCode = (info) => {
	return http.get(`${config.api_user}/sending-vcode/${info.mobileNumber}/${info.vcode}`);
}

export const userRegister = (user) => {
    return http.post(`${config.api_user}/register`, JSON.stringify(user));
}

export const updateUser= (user) => {
	return http.patch(`${config.api_user}/update`, user);
}

export const userLogout = () => {
	return http.delete(`${config.api_user}/logout`);
}

export const deleteUserById = (_id) => {
	return http.delete(`${config.api_user}/remove/${_id}`)
}

export const authToken = ({cancelToken}) => {
	return http.get(`${config.api_user}/auth-token`, {cancelToken});
}


